module.exports = __webpack_public_path__ + "static/media/low-vision.9012d1ac.svg";